module.exports = __webpack_public_path__ + "img/todo.683fc63f.svg";